import { CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js';

export const PAIS_TELEFONO_POR_DEFECTO: CountryCode = 'ES';

export const MENSAJE_TELEFONO_REQUERIDO = 'Requerido.';
export const MENSAJE_TELEFONO_FORMATO_INVALIDO = 'Debe ser un número de teléfono correcto.';

export function telefonoEstaVacio(valor: string | null | undefined): boolean {
  return (valor?.trim() ?? '').length === 0;
}

export function esTelefonoValido(
  valor: string | null | undefined,
  paisPorDefecto: CountryCode = PAIS_TELEFONO_POR_DEFECTO
): boolean {
  const telefono = valor?.trim() ?? '';
  if (!telefono) {
    return false;
  }

  const parsed = telefono.startsWith('+')
    ? parsePhoneNumberFromString(telefono)
    : parsePhoneNumberFromString(telefono, paisPorDefecto);

  return parsed?.isValid() ?? false;
}
